module.exports = __webpack_public_path__ + "static/site-logo-onwhite-dce38df927964206d29db2baa5e8eab7.png";